import type { Auth } from '@/hooks/useAuth';

/** Settings toggle / Explore nudge: management feature opt-in state. */
export const isSmartSearchManagementOn = (auth: Auth | undefined): boolean =>
  auth?.features['smart-search-management']?.status === true;

/** Runtime search UI: effective Smart Search capability for the user. */
export const isUserSmartSearchEnabled = (auth: Auth | undefined): boolean =>
  auth?.user?.permissions?.smartSearch === true;
